var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bpc-booking-event-table',{attrs:{"heading":_vm.$t('global.models.booking-event.heading'),"subheading":_vm.$t('global.models.booking-event.subheading'),"displayConfigName":'daily',"filterConfigName":'daily'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }